document.addEventListener("turbolinks:load", function() {
  mapkit.init({
    authorizationCallback: function(done) {
      fetch("/tokens/map_token")
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          done(json.token);
        });
    },
    language: "en"
  });

  mapkit.addEventListener("configuration-change", function(event) {
    switch (event.status) {
      case "Initialized":
        var geocoder = new mapkit.Geocoder({
          language: "en",
          getsUserLocation: false
        });

        var honolulu = new mapkit.Coordinate(19.8968, 155.5828);
        var map = new mapkit.Map("map", { center: honolulu } );

        var mapDiv = document.getElementById("map");
        // var address = mapDiv.getAttribute("data-address");
        var address = "1600 Kapiolani Blvd. Ste. 1315 Honolulu, Hawaii 96814"
        var name = mapDiv.getAttribute("data-location-name");
        var glyph = mapDiv.getAttribute("data-glyph");
        var glyph2 = mapDiv.getAttribute("data-glyph-2");
        var glyph3 = mapDiv.getAttribute("data-glyph-3");

        geocoder.lookup(address, function(err, data) {
          results = data.results;
          if (results.length > 0) {
            place = results[0]
            console.log(place);
            var marker = new mapkit.MarkerAnnotation(place.coordinate, {
              draggable: true,
              selected: true,
              title: name,
              color: "black",
              glyphColor: "white",
              glyphImage: { 1: glyph, 2: glyph2, 3: glyph3 }
            });
            map.showItems([marker]);
          }
        });
        break;
      case "Refreshed":
        // MapKit JS configuration updated.
        break;
      }
  });
});